export const alphabet = [
  {letter: 'a', type: 'vowel'},
  {letter: 'b', type: 'consonant'},
  {letter: 'c', type: 'consonant'},
  {letter: 'd', type: 'consonant'},
  {letter: 'e', type: 'vowel'},
  {letter: 'f', type: 'consonant'},
  {letter: 'g', type: 'consonant'},
  {letter: 'h', type: 'consonant'},
  {letter: 'i', type: 'vowel'},
  {letter: 'j', type: 'consonant'},
  {letter: 'k', type: 'consonant'},
  {letter: 'l', type: 'consonant'},
  {letter: 'm', type: 'consonant'},
  {letter: 'n', type: 'consonant'},
  {letter: 'o', type: 'vowel'},
  {letter: 'p', type: 'consonant'},
  {letter: 'q', type: 'consonant'},
  {letter: 'r', type: 'consonant'},
  {letter: 's', type: 'consonant'},
  {letter: 't', type: 'consonant'},
  {letter: 'u', type: 'vowel'},
  {letter: 'v', type: 'consonant'},
  {letter: 'w', type: 'consonant'},
  {letter: 'x', type: 'consonant'},
  {letter: 'y', type: 'vowel'},
  {letter: 'z', type: 'consonant'},
  {letter: '1', type: 'consonant'},
  {letter: '2', type: 'consonant'},
  {letter: '3', type: 'consonant'},
  {letter: '4', type: 'consonant'},
  {letter: '5', type: 'consonant'},
  {letter: '6', type: 'consonant'},
];

export const getLetterType = (letter) => {
  return alphabet.find(l => {
    if(l.letter === letter) {
      return l.type
    }
  })
}


